import React from 'react'

const DiagonisticPred = () => {
  return (
    <div>DiagonisticPred</div>
  )
}

export default DiagonisticPred